<template>
  <section class="head-image w-100 bg-cl-th-accent cl-white ">
    <div class="container head-image-bg w-100 h-100 cl-black" v-background-image="s3Path(store.background)">
      <div class="head-image-content w-100 center-xs pt10 pb10">
        <h2 class="middle-xs underline cl-white ">
          {{ store.title }}
        </h2>
        <p class="head-subtitle cl-white">{{store.subtitle}}</p>
        <locations-list route-suffix="/all-discounts" />
      </div>
    </div>
  </section>
</template>
<script>
import HomeLocationsList from 'theme/components/theme/blocks/Locations/HomeLocationsList'
import {mapGetters} from 'vuex';
import {s3Path} from "@vue-storefront/core/helpers";
import backgroundImage from 'theme/directives/background-image';

export default {
  name: 'HeaderDiscounts',
  methods: {s3Path},
  components: {
    'locations-list': HomeLocationsList,
  },
  directives: {
    backgroundImage
  },
  data() {
    return {
      store: {
        background: '../../../assets/bg-home.png',
        title: 'Супер пропозиції',
        subtitle: 'Обирай улюблений товар по супер ціні'
      },
    }
  },
  computed: {
    ...mapGetters({
      currentLocation: 'locations/getActiveLocation',
      metaInformation: 'configs/getMetaInformation',
    }),
    ogMetaType () {
      if (this.metaInformation.find(meta => meta.key === 'og_type')) {
        return this.metaInformation.find(meta => meta.key === 'og_type').value
      }
      return ''
    },

    ogMetaTitle () {
      if (this.metaInformation.find(meta => meta.key === 'og_title')) {
        return this.metaInformation.find(meta => meta.key === 'og_title').value
      }
      return ''
    },

    ogMetaDescription () {
      if (this.metaInformation.find(meta => meta.key === 'og_description')) {
        return this.metaInformation.find(meta => meta.key === 'og_description').value
      }
      return ''
    },

    ogMetaImage () {
      if (this.metaInformation.find(meta => meta.key === 'og_image')) {
        return this.metaInformation.find(meta => meta.key === 'og_image').value
      }
      return ''
    }
  },
  metaInfo () {
    // if location is chosen
    if (this.currentLocation) {
      let currentLocationMeta = [
        {
          vmid: 'og:type',
          property: 'og:type',
          content: this.currentLocation.og_meta_type ? this.currentLocation.og_meta_type : this.ogMetaType
        },
        {
          vmid: 'og:title',
          property: 'og:title',
          content: this.currentLocation.og_meta_title ? this.currentLocation.og_meta_title : this.ogMetaTitle
        },
        {
          vmid: 'og:description',
          property: 'og:description',
          content: this.currentLocation.og_meta_description ? this.currentLocation.og_meta_description : this.ogMetaDescription
        },
        {
          vmid: 'og:image',
          property: 'og:image',
          content: this.currentLocation.og_meta_image ? this.currentLocation.og_meta_image : this.ogMetaImage
        }
      ]

      return {
        title: this.currentLocation.meta_title,
        meta: currentLocationMeta
      }
    }
  },
}
</script>
<style lang="scss" scoped>
.head-image-content h2 {
  margin-bottom: 0;
}
.head-subtitle {
  margin-top: 1%;
}
.head-image {
  position: relative;
  .head-image-bg {
    padding-bottom: 20px;
    padding-top: 54px;
  }
  .image-wrapper {
    width: 95px !important;
    height: 95px !important;
    margin-bottom: 10px;
    border-radius: 50%;
    -webkit-box-shadow: rgba(0, 0, 0, 0.15) 0px 2px 4px;
    box-shadow: rgba(0, 0, 0, 0.15) 0px 2px 4px;
    background-color: white;
    padding: 10px;
    img {
      width: 100%;
      height: auto;
    }
  }

  .head-image-content {
    display: flex;
    flex-direction: column;
    align-items: center;

    a.store-title{
      color: #fff;
    }
  }
}
.container {
  background-size: cover;
  background-position: bottom center;
  background-repeat: no-repeat;
}
@media (max-width: 75em) {
  .store-title {
    font-size: 20px;
  }
}
@media (max-width: 64em) {
  .store-title {
    font-size: 16px;
  }
}

input {
  display: none;
}

#text {
  position: absolute;
  display: block;
  top: 0;
  padding-left: 10px;
  width: calc(100% - 10px);
  text-align: left;
}

.select {
  display: inline-block;
  width: 280px;
  height: 38px;
  line-height: 38px;
  position: relative;
  border-radius: 10px;

  .icon {
    width: 40px;
    height: 40px;
    background-color: #11bb2e;
    position: absolute;
    right: -2px;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
    img{
      padding-top: 8px;
    }
  }
}

.select input[name="list"]:not(:checked) ~ #text {
  color: black;
  background: white;
}

.select input[name="list"]:checked ~ #text {
  background: transparent;
  color: transparent;
  z-index: 2;
}

#select:disabled ~ .items #text {
  background: #eee;
}

.items {
  display: block;
  min-height: 38px;
  position: absolute;
  border: 1px solid #ddd;
  overflow: hidden;
  width: 240px;
  cursor: pointer;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  z-index: 1;
}

#select:not(:checked) ~ .items {
  height: 30px;
}

.items label {
  border-top: 2px solid #ddd;
  display: none;
  padding-left: 10px;
  background: white;
  text-align: left;
}

.items label:hover {
  background: #eee;
  cursor: pointer;
}

#select:checked ~ .items {
  padding-top: 38px;
}

#select:checked ~ .items label {
  display: block;
}

.items input:checked + label {
  display: block!important;
  border: none;
  background: white;
}
</style>
